'use client';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#030812] text-white">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="border-b border-white/10 bg-[linear-gradient(135deg,#07111f_0%,#0f1f3d_100%)] py-16">
          <div className="container mx-auto max-w-6xl px-4">
            <nav className="mb-6 flex items-center gap-2 text-sm text-slate-400">
              <Link href="/" className="hover:text-white transition">Home</Link>
              <span>/</span>
              <span className="text-white">Contact</span>
            </nav>
            <h1 className="text-3xl font-black text-white md:text-4xl">Contact Us</h1>
            <p className="mt-3 max-w-2xl text-slate-300">
              Have a question about a printer, an order, or need help choosing the right model? We are here to help.
            </p>
          </div>
        </section>

        <section className="py-14">
          <div className="container mx-auto max-w-5xl px-4">
            <div className="grid gap-10 md:grid-cols-2">
              {/* Contact Info */}
              <div className="space-y-6">
                <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                  <h2 className="font-bold text-white">Get in Touch</h2>
                  <p className="mt-2 text-sm leading-6 text-slate-300">
                    We aim to respond to all enquiries within 1 business day. For urgent matters, please use the contact form and mark your message as urgent.
                  </p>
                </div>

                <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                  <h3 className="text-xs font-bold uppercase tracking-widest text-violet-300">Business Hours</h3>
                  <ul className="mt-3 space-y-2 text-sm text-slate-300">
                    <li className="flex justify-between"><span>Monday – Friday</span><span className="text-white">9:00 AM – 6:00 PM</span></li>
                    <li className="flex justify-between"><span>Saturday</span><span className="text-white">10:00 AM – 4:00 PM</span></li>
                    <li className="flex justify-between"><span>Sunday</span><span className="text-slate-500">Closed</span></li>
                  </ul>
                </div>

                <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                  <h3 className="text-xs font-bold uppercase tracking-widest text-violet-300">Quick Links</h3>
                  <ul className="mt-3 space-y-2 text-sm">
                    <li><Link href="/guides" className="text-slate-300 hover:text-white transition">→ Printer Buying Guides</Link></li>
                    <li><Link href="/refund-and-return" className="text-slate-300 hover:text-white transition">→ Refund & Return Policy</Link></li>
                    <li><Link href="/shipping-policy" className="text-slate-300 hover:text-white transition">→ Shipping Policy</Link></li>
                  </ul>
                </div>
              </div>

              {/* Contact Form */}
              <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-8">
                <h2 className="font-black text-white text-xl">Send a Message</h2>
                <form className="mt-6 space-y-5" onSubmit={(e) => e?.preventDefault()}>
                  <div>
                    <label className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1.5">Full Name</label>
                    <input
                      type="text"
                      placeholder="Your name"
                      className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder-slate-500 focus:border-violet-500 focus:outline-none"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1.5">Email Address</label>
                    <input
                      type="email"
                      placeholder="you@example.com"
                      className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder-slate-500 focus:border-violet-500 focus:outline-none"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1.5">Subject</label>
                    <select className="w-full rounded-lg border border-white/10 bg-[#07111f] px-4 py-3 text-sm text-white focus:border-violet-500 focus:outline-none">
                      <option value="">Select a topic</option>
                      <option>Product Enquiry</option>
                      <option>Order Support</option>
                      <option>Returns & Refunds</option>
                      <option>Technical Help</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1.5">Message</label>
                    <textarea
                      rows={5}
                      placeholder="Describe your question or issue..."
                      className="w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder-slate-500 focus:border-violet-500 focus:outline-none resize-none"
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full rounded-lg bg-violet-600 py-3 text-sm font-bold text-white transition hover:bg-violet-500"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
